Vue.component('inline-slider', {
    props: ['slides'],

    data() {
        return {
            // Third-party
            hammertime: null,

            currentIndex: 0,
            imageTransition: 'transition-inline-slider-right',
        };
    },

    watch: {
        nextSlide(newSlide, oldSlide) {
            if (newSlide) {
                EventBus.$emit('next-slide-set');
            }
            Vue.nextTick(() => {
                if (objectFitPolyfill !== undefined) {
                    objectFitPolyfill();
                }
            });
        },
    },

    mounted() {
        this.initHammerTime();
    },

    methods: {

        next() {
            if (this.inTransition) {
                return;
            }

            this.imageTransition = 'transition-inline-slider-right';
            this.inTransition = true;
            const nextIndex = this.currentIndex + 1;

            if (nextIndex > this.slides.length - 1) {
                this.currentIndex = 0;
                return;
            }

            this.currentIndex = nextIndex;
        },

        previous() {
            if (this.inTransition) {
                return;
            }

            this.imageTransition = 'transition-inline-slider-left';
            this.inTransition = true;

            const previousIndex = this.currentIndex - 1;

            if (previousIndex < 0) {
                this.currentIndex = this.slides.length - 1;
                return;
            }

            this.currentIndex = previousIndex;
        },

        afterEnter(el) {
            this.inTransition = false;
        },

        /**
         * Initialize Hammertime
         *
         * @return {void}
         */
        initHammerTime() {
            this.hammertime = new Hammer(this.$el, {});
            this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });

            this.hammertime.on('swipeleft', (ev) => {
                this.next();
            });

            this.hammertime.on('swiperight', (ev) => {
                this.previous();
            });

            this.hammertime.on('swipeup', (ev) => {
                this.transitionToStory();
            });
        },

    },

    beforeDestroy() {
        this.hammertime.off('swipeleft');
        this.hammertime.off('swiperight');
        this.hammertime.off('swipeup');
        this.hammertime.destroy();
        this.hammertime = null;
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/inline-slider.js